import { gql } from '@apollo/client'

export const GET_TOP_EMPTY_PRODUCTS = gql`
  query GetTopEmptyProducts($filters: DashboardRankFilter!) {
    topEmptyProducts(filters: $filters) {
      label
      value
      total
      rankValue
    }
  }
`
